<template>
    <div class="ticket-list">
        <div class="toolbar-container">
        
            <TicketFilterToolbar
                v-model="filters"
                :status-list="statusList"
                :default-filter-template="defaultFilterTemplate"
                ref="filterToolbar"
            />
            <div class="d-flex gap-5">
                <SupsisButton @click="refreshData" primary small>
                    <small class="keyboard-shortcut">⌥R</small>
                    {{ $t("message.refresh") }}
                </SupsisButton>
                <!-- Ayarlar Butonu -->
                <SupsisButton @click="openColumnSettings" small>
                    <i class="fas fa-cog"></i>
                </SupsisButton>
                <div class="view-switcher">
                    <div class="supsis-button-group">
                        <SupsisButton @click="setMode('list')" :primary="mode === 'list'" small>
                            <i class="fas fa-list"></i>
                        </SupsisButton>
                        <SupsisButton @click="setMode('kanban')" :primary="mode === 'kanban'" small>
                            <i class="fas fa-columns"></i>
                        </SupsisButton>
                    </div>
                    <!-- Sesli Asistan Tuşu -->
                    <!--                    geçici süreliğine kapatıldı hatalar giderilene kadar-->
                    <!--                    <SupsisButton @click="openVoiceAssistantModal" small>-->
                    <!--                        <img src="/static/img/copilot.png" width="25" height="25" />-->
                    <!--                    </SupsisButton>-->
                </div>
            </div>
        </div>
        <!-- Toplu Eylem Çubuğu -->
        <div v-if="checkboxOption.selectedRowKeys.length > 0" class="bulk-action-bar">
            <div class="selected-count">
                {{ checkboxOption.selectedRowKeys.length }} {{ $t("ticket.ticketSelection") }}
            </div>
            <div class="bulk-actions">
                <SupsisButton @click="selectAll" type="default" class="bulk-action-button select-all">
                    <small class="keyboard-shortcut">⌘A</small>
                    {{ $t("chatbotv2.selectAll") }}
                </SupsisButton>
                <SupsisButton @click="deselectAll" type="default" class="bulk-action-button deselect-all">
                    <small class="keyboard-shortcut">⌘D</small>
                    {{ $t("message.cancel") }}
                </SupsisButton>
                <SupsisButton @click="showBulkAssignModal" type="primary" class="bulk-action-button assign-agent">
                    <small class="keyboard-shortcut">⌘T</small>
                    {{ $t("message.assignRep") }}
                </SupsisButton>
                <SupsisButton @click="bulkCloseTickets" type="warning" class="bulk-action-button close-tickets">
                    <small class="keyboard-shortcut">⌘K</small>
                    {{ $t("ticket.bulkClose") }}
                </SupsisButton>
                <SupsisButton @click="deleteSelectedTickets" type="danger" class="bulk-action-button delete-tickets">
                    <small class="keyboard-shortcut">⌘X</small>
                    {{ $t("message.delete") }}
                </SupsisButton>
            </div>
        </div>
        <div v-if="mode === 'list'">
            <supsis-table
                :columns="columns"
                :rows="tickets"
                :bottom-pagination="true"
                :pagination-cursor="paginationCursor"
                @cursor-changed="onCursorChanged"
                :options="{ eventCustomOption, checkboxOption }"
                id="ticket-list-table"
                :attributes="{
                    style: { width: getMaxWidth() + 'px' },
                    'scroll-width': getMaxWidth() + 180,
                }"
            >
            </supsis-table>
            <Modal2
                v-if="isBulkAssignModalVisible"
                :title="$t('ticket.collectiveRepAppointment')"
                showFooter
                className="agent-picker-modal"
                @cancel="closeBulkAssignModal"
                @ok="handleBulkAssignConfirm"
            >
                <AgentPicker v-model="selectedBulkAgent" single @confirm="handleBulkAssignConfirm" />
            </Modal2>
        </div>
        <div v-else-if="mode === 'kanban'">
            <TicketKanbanBoard
                :tickets="tickets"
                :statusList="statusList"
                @load-more-tickets="loadMoreTickets"
                @update-ticket-status="({ ticketId, statusTitle }) => handleChangeStatus(ticketId, statusTitle)"
                @toggle-ticket-selection="toggleTicketSelection"
                @toggle-select-all="toggleSelectAll"
                @ticket-clicked="viewTicketFromKanban"
                :selectedTickets="checkboxOption.selectedRowKeys"
            />
        </div>

        <!-- Ticket Detay Modalı - Her iki mod için de kullanılır -->
        <AwaitingTicketDetails
            v-if="showingTicket"
            :ticket="showingTicket"
            @close="showingTicket = null"
            @confirm="sendResponse"
            @replyTrendyolQuestion="replyTrendyolQuestion"
            @sendAsComment="sendAsComment"
            @deleteComment="deleteComment"
            @changeHideStatusIGComment="changeHideStatusIGComment"
            :statusList="statusList"
            :change-ticket-status="handleChangeStatus"
            @navigate="navigateTicket"
            @close-ticket="closeTicket"
        />

        <Modal2
            v-if="isAgentPickerVisible"
            :title="$t('ticket.appointingRepresentative')"
            showFooter
            className="agent-picker-modal"
            @cancel="closeAgentPicker"
            @ok="handleAgentPickerConfirm"
        >
            <AgentPicker v-model="selectedTicket.agents" single @confirm="handleAgentPickerConfirm" />
        </Modal2>
        <TicketVoiceAssistantManual v-if="isVoiceAssistantModalVisible" @close="isVoiceAssistantModalVisible = false" />
        <!-- Kolon Ayarları Modali -->
        <Modal2
            v-if="isColumnSettingsModalVisible"
            :title="$t('ticket.columnSettings')"
            :showFooter="false"
            className="column-settings-modal"
            @cancel="closeColumnSettings"
        >
            <ColumnSelector
                v-model="selectedColumns"
                :ticket-fields="ticketFields"
                :contact-property-fields="contactPropertyFields"
                @save="saveColumnSettings"
                @cancel="closeColumnSettings"
            />
        </Modal2>
    </div>
</template>
<script>
import Vue from "vue";
import SupsisTable from "../../../../components/SupsisTable.vue";
import AwaitingTicketDetails from "./AwaitingTicketDetails.vue";
import { getPersistenceData } from "../../../../utils/persistenceStorage";
import { PERMISSION_TYPES } from "../../../../language/permissionTypes";
import { mapActions, mapGetters, mapState } from "vuex";
import { addTicketStatus, readTicketStatus, TICKET_API } from "../../../../api/ticket";
import { sendSocketMessage } from "../../../../utils/socketStream";
import ActionEdit from "../../../../components/svg/ActionEdit.vue";
import TicketFilterToolbar from "./TicketFilterToolbar.vue";
import log2 from "../../../../utils/log2";
import _ from "lodash";
import TicketStatusSwitcher from "./TicketStatusSwitcher.vue";
import Modal2 from "../../../../components/common/Modal2.vue";
import AgentPicker from "../../../../components/pickers/AgentPicker.vue";
import AgentAvatar from "../../../../components/common/AgentAvatar.vue";
import { VeLoading } from "vue-easytable";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import HoverMenuCell from "../../../../components/common/HoverMenuCell.vue";
import TicketKanbanBoard from "./TicketKanbanBoard.vue";
import SYSTEM_PUBSUB from "../../../../utils/systemPubSub";
import { filter } from "rxjs/operators";
import TicketVoiceAssistantManual from "./TicketVoiceAssistantManual.vue";
import ColumnSelector from "./ColumnSelector.vue";
import { isMaskContactInfo, maskContactInfo } from "../../../../utils/utils"; // ColumnSelector bileşenini ekledik

const log = log2("TicketList");
export default Vue.extend({
    name: "TicketList",
    components: {
        TicketFilterToolbar,
        AwaitingTicketDetails,
        SupsisTable,
        ActionEdit,
        TicketStatusSwitcher,
        Modal2,
        AgentPicker,
        AgentAvatar,
        SupsisButton,
        HoverMenuCell,
        TicketKanbanBoard,
        TicketVoiceAssistantManual,
        ColumnSelector,
    },
    props: {
        defaultFilterTemplate: {
            type: String,
            default: "custom",
        },
    },
    data() {
        return {
            isColumnSettingsModalVisible: false,
            selectedColumns: [],

            isVoiceAssistantModalVisible: false,
            hasSeenVoiceAssistantModal: false,
            isBulkAssignModalVisible: false,
            selectedBulkAgent: null,
            loading: false,
            tickets: [],
            total: 0,
            statusList: [],
            checkboxOption: {
                selectedRowKeys: [],
                // row select change event
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    console.log("selectedRowChange", { row, isSelected, selectedRowKeys });
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
                // selected all change event
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    console.log("selectedAllChange", { isSelected, selectedRowKeys });
                    this.checkboxOption.selectedRowKeys = selectedRowKeys;
                },
            },
            filters: [
                {
                    name: "dateFilter",
                    label: this.$t("ticket.ticketFilterList.creationDate"),
                    materialIcon: "event",
                    controlProps: {},
                    controlType: "date-range-picker",
                    defaultValue: {
                        timeSelect: "isoWeek",
                        startDate: null,
                        endDate: null,
                    },
                    filterValue: {
                        timeSelect: "isoWeek",
                        startDate: null,
                        endDate: null,
                    },
                },
                {
                    name: "resolved",
                    label: this.$t("headBar.completed"),
                    materialIcon: "check_circle",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: this.$t("makeChoice"),
                    },
                    defaultValue: null,
                    filterValue: false,
                    options: () => [
                        { id: false, label: this.$t("message.no") },
                        { id: true, label: this.$t("message.yes") },
                        { id: null, label: this.$t("message.doesntMatter") },
                    ],
                },
                {
                    name: "channels",
                    label: this.$t("headBar.channel"),
                    materialIcon: "swap_horiz",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: true,
                        idKey: "id",
                        labelKey: "label",
                        title: this.$t("makeChoice"),
                    },
                    defaultValue: [],
                    filterValue: [],
                    options: () => this.getUniqueChannels(),
                },
            ],
            page: 1,
            perPage: !isNaN(getPersistenceData("ticket-page-size") || "undefined")
                ? parseInt(getPersistenceData("ticket-page-size"))
                : 10,
            currentSort: {
                columnKey: "createdDate",
                order: "ascend",
            },
            pageSizes: ["10", "25", "50", "100"],
            agents: null,
            showingTicket: null,
            paginationCursor: {
                total: 0,
                page: 1,
                perPage: 10,
            },

            eventCustomOption: {
                bodyCellEvents: () => {
                    return {
                        dblclick: (event) => {
                            const columnIndex = event.target.cellIndex;
                            const column = this.columns()[columnIndex];
                            if (!column) return;
                            if (column.copyDisabled) {
                                return;
                            }
                            let text = event.toElement.innerText;
                            let textArea = document.createElement("textarea");
                            textArea.value = text;
                            document.body.appendChild(textArea);
                            textArea.select();
                            document.execCommand("copy");
                            document.body.removeChild(textArea);
                            this.$message.success({
                                content: this.$t("message.copiedClipboard"),
                                duration: 2,
                                key: "saved",
                            });
                        },
                    };
                },
            },
            loadingInstance: null,
            mode: "list",
            kanbanFetchLimit: 100,
            isInitialFetch: true,
            isAgentPickerVisible: false,
            selectedTicket: null,
            currentTicketIndex: -1,
        };
    },
    computed: {
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapState({
            waitingTickets: (state) => state.ticket.waitingTickets,
            ticketTags: (state) => state.ticket.topics,
            users: (state) => state.user.users,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            contactProperties: (state) => state.contactProperty.data, // contactProperty'leri aldık
            channels: (state) => state.channel.channels,
        }),
        ...mapGetters({
            getUser: "user/getUser",
            checkPermission: "auth/checkPermission",
        }),
        ticketFields() {
            return [
                { key: "email", label: this.$t("headBar.email") },
                { key: "name", label: this.$t("headBar.name") },
                { key: "phone", label: this.$t("headBar.phone") },
                // Diğer mevcut kolonlar
                { key: "source", label: this.$t("headBar.source") },
                { key: "status", label: this.$t("headBar.situation") },
                { key: "subject", label: this.$t("headBar.subject") },
                { key: "tag", label: this.$t("headBar.label") },
                { key: "resolved", label: this.$t("headBar.completed") },
                { key: "createdDate", label: this.$t("headBar.date") },
                { key: "agents", label: this.$t("headBar.representative") },
                { key: "channel", label: this.$t("headBar.channel") },
                // İşlemler kolonu eklemiyoruz çünkü sabit
            ];
        },
        contactPropertyFields() {
            return this.contactProperties.map((property) => ({
                key: property._id,
                label: property.label,
            }));
        },
        allColumns() {
            const columns = {
                checkbox: {
                    field: "",
                    key: "a",
                    type: "checkbox",
                    title: "",
                    width: 50,
                    align: "center",
                },
                email: {
                    title: this.$t("headBar.email"),
                    field: "email",
                    key: "email",
                    width: 100,
                    renderBodyCell: ({ row }) => {
                        return (
                            <HoverMenuCell
                                filterAdd={!this.isFilterExists("email")}
                                filterRemove={this.isFilterExists("email")}
                                copy={true}
                                onFilterAdded={() =>
                                    this.addFilter(
                                        "email",
                                        this.maskContactInfo(
                                            row.visitorEmailAddress || this.getVisitorValue(row, "email"),
                                            "email",
                                            5
                                        )
                                    )
                                }
                                onFilterRemoved={() => this.removeFilter("email")}
                            >
                                {this.maskContactInfo(
                                    row.visitorEmailAddress || this.getVisitorValue(row, "email"),
                                    "email",
                                    5
                                )}
                            </HoverMenuCell>
                        );
                    },
                },
                name: {
                    title: this.$t("headBar.name"),
                    field: "name",
                    key: "name",
                    width: 100,
                    renderBodyCell: ({ row }) => {
                        return (
                            <HoverMenuCell
                                filterAdd={!this.isFilterExists("name")}
                                filterRemove={this.isFilterExists("name")}
                                copy={true}
                                onFilterAdded={() => this.addFilter("name", this.getVisitorValue(row, "name"))}
                                onFilterRemoved={() => this.removeFilter("name")}
                            >
                                {this.getVisitorValue(row, "name")}
                            </HoverMenuCell>
                        );
                    },
                },
                phone: {
                    title: this.$t("headBar.phone"),
                    field: "phone",
                    key: "phone",
                    width: 100,
                    renderBodyCell: ({ row }) => {
                        return (
                            <HoverMenuCell
                                filterAdd={!this.isFilterExists("phone")}
                                filterRemove={this.isFilterExists("phone")}
                                copy={true}
                                onFilterAdded={() =>
                                    this.addFilter(
                                        "phone",
                                        this.maskContactInfo(
                                            row.visitorPhoneNumber || this.getVisitorValue(row, "phone"),
                                            "phone",
                                            5
                                        )
                                    )
                                }
                                onFilterRemoved={() => this.removeFilter("phone")}
                            >
                                {this.maskContactInfo(
                                    row.visitorPhoneNumber || this.getVisitorValue(row, "phone"),
                                    "phone",
                                    5
                                )}
                            </HoverMenuCell>
                        );
                    },
                },
                source: {
                    title: this.$t("headBar.source"),
                    field: "type",
                    key: "source",
                    width: 150,
                    renderBodyCell: ({ row }) => {
                        let source;
                        let filterTypes;
                        if (row.tag === "offline_message") {
                            source = "Web";
                            filterTypes = ["offline"];
                        } else {
                            switch (row.type) {
                                case "instagram-mention":
                                case "instagram-comment":
                                    source = "Instagram";
                                    filterTypes = ["instagram-mention", "instagram-comment"];
                                    break;
                                case "page-comment":
                                    source = "Facebook";
                                    filterTypes = ["page-comment"];
                                    break;
                                case "chatbot":
                                    source = "Chatbot";
                                    filterTypes = ["chatbot"];
                                    break;
                                case "trendyol":
                                    source = "Trendyol";
                                    filterTypes = ["trendyol"];
                                    break;
                                case "form":
                                    source = "Supsis Form Talebi";
                                    filterTypes = ["form"];
                                    break;
                                case "automation":
                                    source = "Otomasyon Talebi";
                                    filterTypes = ["automation"];
                                    break;
                                case "ticket":
                                    source = "Otomasyon ile Gelen";
                                    filterTypes = ["automation"];
                                    break;
                                default:
                                    source = "Chatbot";
                                    filterTypes = ["chatbot"];
                            }
                        }
                        if (!!row.osr) {
                            source = "Web Talep Formu";
                            filterTypes = ["offline"];
                        }
                        return (
                            <HoverMenuCell
                                filterAdd={!this.isFilterExists("types")}
                                filterRemove={this.isFilterExists("types")}
                                onFilterAdded={() => this.addFilter("types", filterTypes)}
                                onFilterRemoved={() => this.removeFilter("types")}
                            >
                                {source}
                            </HoverMenuCell>
                        );
                    },
                },
                status: {
                    title: this.$t("headBar.situation"),
                    field: "status",
                    key: "status",
                    copyDisabled: true,
                    width: 400,
                    renderBodyCell: ({ row }) => {
                        return (
                            <TicketStatusSwitcher
                                currentStatus={row.status}
                                statusList={this.statusList}
                                v-on:update-status={(newStatus) => this.handleChangeStatus(row._id, newStatus)}
                            />
                        );
                    },
                },
                subject: {
                    title: this.$t("headBar.subject"),
                    field: "subject",
                    key: "subject",
                    width: 150,
                    copyDisabled: true,
                    renderBodyCell: ({ row }) => {
                        return (
                            <HoverMenuCell
                                filterAdd={!this.isFilterExists("subject")}
                                filterRemove={this.isFilterExists("subject")}
                                onFilterAdded={() => this.addFilter("subject", row.subject)}
                                onFilterRemoved={() => this.removeFilter("subject")}
                            >
                                {row.subject}
                            </HoverMenuCell>
                        );
                    },
                },
                tag: {
                    title: this.$t("headBar.label"),
                    field: "tag",
                    width: 150,
                    key: "tag",
                    renderBodyCell: ({ row }) => {
                        const _tag = row.tag;
                        const chipClasses = {
                            "instagram-comment": "chip instagram-comment",
                            "instagram-mention": "chip instagram-mention",
                            "page-comment": "chip page-comment",
                            offline_message: "chip offline-message",
                        };

                        return (
                            <HoverMenuCell
                                filterAdd={!this.isFilterExists("tags")}
                                filterRemove={this.isFilterExists("tags")}
                                onFilterAdded={() => this.addFilter("tags", [row.tag])}
                                onFilterRemoved={() => this.removeFilter("tags")}
                            >
                                {chipClasses[_tag] ? <div class={chipClasses[_tag]}>{_tag}</div> : <div>{_tag}</div>}
                            </HoverMenuCell>
                        );
                    },
                },
                resolved: {
                    title: this.$t("headBar.completed"),
                    field: "resolved",
                    width: 150,
                    key: "resolved",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div class={row.resolved ? "chip resolved" : "chip unresolved"}>
                                {row.resolved ? this.$t("task.completed") : this.$t("wp.running")}
                            </div>
                        );
                    },
                },
                createdDate: {
                    title: this.$t("headBar.date"),
                    field: "createdDate",
                    key: "createdDate",
                    width: 150,
                    renderBodyCell: ({ row }) => {
                        return this.$moment(row.createdDate).format("DD.MM.YYYY HH:mm");
                    },
                },
                agents: {
                    title: this.$t("headBar.representative"),
                    field: "agents",
                    key: "agents",
                    copyDisabled: true,
                    width: 150,
                    fixed: "right",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div class="agent-cell" onClick={() => this.openAgentPicker(row)}>
                                <AgentAvatar
                                    userID={row.assignedUser ? row.assignedUser._id : ""}
                                    size={30}
                                    singleChar
                                />
                                <span class="agent-name">
                                    {row.assignedUser ? (
                                        row.assignedUser.name
                                    ) : (
                                        <span class="assign-link">+ {this.$t("ticket.makeAssignment")}</span>
                                    )}
                                </span>
                            </div>
                        );
                    },
                },
                channel: {
                    title: "Kanal",
                    field: "channel",
                    key: "channel",
                    width: 120,
                    renderBodyCell: ({ row }) => {
                        const channelId =
                            _.get(row, "visitor.channel._id") || _.get(row, "conversation.visitor.channel._id");
                        const channelName =
                            _.get(row, "visitor.channel.name") ||
                            _.get(row, "conversation.visitor.channel.name") ||
                            "-";
                        return (
                            <HoverMenuCell
                                filterAdd={!this.isFilterExists("channels")}
                                filterRemove={this.isFilterExists("channels")}
                                onFilterAdded={() => this.addFilter("channels", [channelId])}
                                onFilterRemoved={() => this.removeFilter("channels")}
                            >
                                {channelName}
                            </HoverMenuCell>
                        );
                    },
                },
            };

            // Contact Property kolonlarını ekleyelim
            this.contactProperties.forEach((property) => {
                columns[property._id] = {
                    title: property.label,
                    key: property._id,
                    width: 150,
                    renderBodyCell: ({ row }) => {
                        const contactProperty = row.visitor.contactProperties.find(
                            (cp) => cp.property === property._id
                        );
                        return contactProperty ? contactProperty.value : "-";
                    },
                };
            });

            return columns;
        },
        columns() {
            const result = [];

            // Checkbox kolonunu ekle (her zaman ilk kolon olacak)
            result.push(this.allColumns.checkbox);

            // Seçili kolonları ekle
            this.selectedColumns.forEach((key) => {
                if (this.allColumns[key]) {
                    result.push(this.allColumns[key]);
                }
            });

            // İşlemler kolonunu ekle (her zaman son kolon olacak)
            result.push({
                title: this.$t("message.transactions"),
                field: "_id",
                key: "_id",
                copyDisabled: true,
                fixed: "right",
                width: 200,
                renderBodyCell: ({ row }) => {
                    return (
                        <div class="ticket-transactions">
                            {this.checkPermission(PERMISSION_TYPES["offlineSupportRequest.update"].tr.name) && (
                                <a-button
                                    class="btnAction"
                                    on-click={() => this.view(row)}
                                    v-tippy={{ followCursor: true, placement: "bottom-end" }}
                                    content={this.$t("task.view")}
                                >
                                    <ActionEdit />
                                </a-button>
                            )}
                            {this.checkPermission(PERMISSION_TYPES["offlineSupportRequest.delete"].tr.name) && (
                                <a-button
                                    class="btnAction"
                                    on-click={() => this.archived(row)}
                                    v-tippy={{ followCursor: true, placement: "bottom-end" }}
                                    content={this.$t("message.archived")}
                                >
                                    <md-icon style="color: #3fc5bd">inventory_2</md-icon>
                                </a-button>
                            )}
                            {this.checkPermission(PERMISSION_TYPES["offlineSupportRequest.delete"].tr.name) && (
                                <a-button
                                    class="btnAction"
                                    on-click={() => this.deleteTicket(row)}
                                    v-tippy={{ followCursor: true, placement: "bottom-end" }}
                                    content="Sil"
                                >
                                    <md-icon style="color: red">delete</md-icon>
                                </a-button>
                            )}
                        </div>
                    );
                },
            });

            return result;
        },
    },

    methods: {
        ...mapActions({
            assignRepresentative: "ticket/assignRepresentative",
            getUsers: "user/getUsers",
            sendTicketResponse: "ticket/sendTicketResponse",
            fetchTopics: "ticket/fetchTopics",
            updateFormStatus: "forms/updateFormStatus",
        }),
        openColumnSettings() {
            this.isColumnSettingsModalVisible = true;
        },
        closeColumnSettings() {
            this.isColumnSettingsModalVisible = false;
        },
        saveColumnSettings() {
            // Seçilen kolonları localStorage'a kaydedelim
            localStorage.setItem("ticketListColumns", JSON.stringify(this.selectedColumns));
            this.closeColumnSettings();
        },
        async closeTicket(ticketId) {
            try {
                await this.closeTicketAndUpdateState(ticketId);
                this.$message.success("Ticket başarıyla kapatıldı.");
                this.fetch(); // Listeyi yenile
            } catch (error) {
                console.error("Ticket kapatma hatası:", error);
                this.$message.error("Ticket kapatılırken bir hata oluştu.");
            }
        },
        openVoiceAssistantModal() {
            this.isVoiceAssistantModalVisible = true;
            this.hasSeenVoiceAssistantModal = true;
            localStorage.setItem("hasSeenVoiceAssistantModal", "true");
        },
        checkVoiceAssistantModal() {
            const hasSeen = localStorage.getItem("hasSeenVoiceAssistantModal");
            if (!hasSeen) {
                setTimeout(() => {
                    if (!this.hasSeenVoiceAssistantModal) {
                        this.openVoiceAssistantModal();
                    }
                }, 5000); // 5 saniye sonra göster
            }
        },
        getMaxWidth() {
            return window.innerWidth - 180;
        },
        deleteSelectedTickets() {
            this.$confirm({
                title: this.$t("ticket.bulkDeleteConfirmation"),
                content: `${this.checkboxOption.selectedRowKeys.length} ${this.$t("ticket.sureWantToDeleteTicket")}`,
                okText: this.$t("message.yes"),
                cancelText: this.$t("message.no"),
                onOk: async () => {
                    try {
                        await TICKET_API.deleteMultiTicket(this.checkboxOption.selectedRowKeys);
                        this.$message.success(this.$t("ticket.selectedTicketSucsDelete"));
                        this.paginationCursor.total -= this.checkboxOption.selectedRowKeys.length; // Toplam bilet sayısını güncelle
                        this.checkboxOption.selectedRowKeys = []; // Seçili öğeleri temizle
                        this.fetch(); // Listeyi yenile
                    } catch (error) {
                        console.error("Toplu bilet silme hatası:", error);
                        this.$message.error(this.$t("ticket.thereErrorDeletingTicket"));
                    }
                },
                onCancel() {
                    // İptal edildiğinde yapılacak bir şey yok
                },
            });
        },
        async deleteTicket(row) {
            this.$confirm({
                title: this.$t("ticket.deleteConfirm"),
                content: this.$t("ticket.sureDeleteTicket"),
                okText: this.$t("message.yes"),
                cancelText: this.$t("message.no"),
                onOk: async () => {
                    try {
                        await TICKET_API.deleteMultiTicket([row._id]);
                        this.$message.success(this.$t("ticket.ticketSucsDelete"));
                        this.fetch(); // Listeyi yenile
                    } catch (error) {
                        console.error("Bilet silme hatası:", error);
                        this.$message.error("Bilet silinirken bir hata oluştu.");
                    }
                },
                onCancel() {
                    // İptal edildiğinde yapılacak bir şey yok
                },
            });
        },
        refreshData() {
            this.fetch();
        },
        handleKeyDown(event) {
            if ((event.altKey || event.ctrlKey || event.metaKey) && (event.key === "r" || event.key === "R")) {
                event.preventDefault();
                this.refreshData();
            }
            if ((event.metaKey || event.ctrlKey) && (event.key === "a" || event.key === "A")) {
                event.preventDefault();
                this.selectAll();
            }
            if ((event.metaKey || event.ctrlKey) && (event.key === "d" || event.key === "D")) {
                event.preventDefault();
                this.deselectAll();
            }
            if ((event.metaKey || event.ctrlKey) && (event.key === "t" || event.key === "T")) {
                event.preventDefault();
                this.showBulkAssignModal();
            }
            if ((event.metaKey || event.ctrlKey) && (event.key === "k" || event.key === "K")) {
                event.preventDefault();
                this.bulkCloseTickets();
            }
            if ((event.metaKey || event.ctrlKey) && (event.key === "x" || event.key === "X")) {
                event.preventDefault();
                this.deleteSelectedTickets();
            }
            if (this.showingTicket) {
                if ((event.altKey || event.ctrlKey) && event.key === "ArrowLeft") {
                    event.preventDefault();
                    this.navigateTicket(-1);
                } else if ((event.altKey || event.ctrlKey) && event.key === "ArrowRight") {
                    event.preventDefault();
                    this.navigateTicket(1);
                }
            }
        },
        openAgentPicker(ticket) {
            this.selectedTicket = _.cloneDeep(ticket);
            this.selectedTicket.agents = this.selectedTicket.assignedUser
                ? [
                      {
                          type: "agent",
                          value: this.selectedTicket.assignedUser?._id,
                      },
                  ]
                : [];
            this.isAgentPickerVisible = true;
        },
        closeAgentPicker() {
            this.isAgentPickerVisible = false;
            this.selectedTicket = null;
        },
        handleAgentPickerConfirm() {
            if (this.selectedTicket?.agents?.length > 0) {
                const agentId = this.selectedTicket.agents[0].value;
                this.handleChange(agentId, this.selectedTicket._id);
            }
            this.closeAgentPicker();
        },
        generateFilterParams() {
            return this.filters
                .map((filter) => {
                    if (filter.name === "agents") {
                        return {
                            key: "agents",
                            value: (filter.filterValue || []).map((x) => x.value),
                        };
                    } else if (filter.name === "resolved" && typeof filter.filterValue === "boolean") {
                        return {
                            key: filter.name,
                            value: filter.filterValue,
                        };
                    } else {
                        return {
                            key: filter.name,
                            value: filter.filterValue,
                        };
                    }
                })
                .filter((x) => !!x)
                .reduce((acc, curr) => {
                    acc[curr.key] = curr.value;
                    return acc;
                }, {});
        },

        fetchTicketStatusList() {
            readTicketStatus().then(({ data }) => {
                this.statusList = data;
            });
        },
        getVisitorValue(item, field) {
            if (field === "name") {
                return item.osrPayload?.name || item.visitor?.fullname || item.conversation?.fullname || "-";
            } else if (field === "email") {
                return item.osrPayload?.email || item.visitor?.email || item.conversation?.email || "-";
            } else if (field === "phone") {
                return item.osrPayload?.phone || item.visitor?.phone || item.visitor?.whatsappNumber || "-";
            }
            let value = !!item.conversation
                ? item.conversation[field] || "-"
                : !!item.osrPayload
                ? item.osrPayload[field]
                : null;
            if (item.createdByChatbot) {
                if (field === "email") {
                    value = item.visitorEmailAddress || value;
                }
                if (field === "phone") {
                    value = item.visitorPhoneNumber || value;
                }
            }
            return value || item.visitor?.[field] || item[field] || "-";
        },
        async handleChange(repId, _id) {
            log("handleChange", repId, _id);
            await this.assignRepresentative({ _id, repId });
            this.tickets = this.tickets.map((ticket) => {
                if (ticket._id === _id) {
                    ticket.assignedUser = this.users.data.find((x) => x._id === repId);
                }
                return ticket;
            });
            this.$message.success(this.$t("ticket.represantiveSucsAppoint"));
        },
        async closeTicketAndUpdateState(id) {
            try {
                await TICKET_API.close(id);
                this.$message.success(this.$t("ticket.ticketClosedSucs"));
                this.tickets = this.tickets.map((ticket) => {
                    if (ticket._id === id) {
                        ticket.resolved = true;
                    }
                    let ticketId = this.tickets.find(t => t._id === id);
                    if (ticketId && ticketId.type === "form") {
                        this.updateFormStatus({
                            siteId: this.site._id,
                            submissionId: ticketId.formSubmission,
                            newStatus: "ticket",
                        });
                    }
                    return ticket;
                });
                if (this.showingTicket && this.showingTicket._id === id) {
                    this.showingTicket.resolved = true;
                }
            } catch (error) {
                this.$message.error(this.$t("ticket.ticketCloureFailed"));
            }
        },
        async handleChangeStatus(id, status) {
            if (!status || status === this.$t("ticket.unprocessed")) {
                this.$message.error(this.$t("ticket.pleaseSelectValidStatus"));
                return;
            }
            log("handleChangeStatus", id, status);
            try {
                await addTicketStatus({ id, title: status });
                this.$message.success(this.$t("ticket.ticketStatusBeenUpdatd"));
                this.tickets = this.tickets.map((ticket) => {
                    if (ticket._id === id) {
                        ticket.status = status;
                    }
                    return ticket;
                });
                if (this.showingTicket) {
                    this.showingTicket.status = status;
                }

                // Eğer yeni durum statusList'in son durumu ise onay modal'ı göster
                if (status === this.statusList[this.statusList.length - 1].title) {
                    this.$confirm({
                        title: this.$t("ticket.doYouWantCloseTicket"),
                        content: this.$t("ticket.ticketWillMarkedClosed"),
                        onOk: async () => {
                            await this.closeTicketAndUpdateState(id);
                        },
                        onCancel() {
                            console.log("Cancel");
                        },
                    });
                }
            } catch (error) {
                console.error("handleChangeStatus", error);
                this.$message.error(this.$t("ticket.errorUpdatingTicketFailed"));
            }
        },
        view(item, index) {
            log("view", item, index);
            if (isNaN(index)) {
                index = this.tickets.findIndex((x) => x._id === item._id);
            }
            this.showingTicket = item;
            this.currentTicketIndex = index || 0;
        },
        navigateTicket(direction) {
            const newIndex = this.currentTicketIndex + direction;
            log("navigateTicket", { direction, newIndex, next: this.tickets[newIndex] });
            if (newIndex >= 0 && newIndex < this.tickets.length) {
                this.view(this.tickets[newIndex], newIndex);
            }
        },
        sendResponse({ selectedHistory, responseText, senderMailId, resolved }) {
            console.log("TicketList sendResponse..", { selectedHistory, responseText, senderMailId, resolved });

            // Customer email'i ticket'tan al
            const customerEmail = selectedHistory.ticket.visitorEmailAddress ||
                                selectedHistory.ticket.visitor?.email ||
                                selectedHistory.ticket.osrPayload?.email;

            let data = {
                _id: selectedHistory.ticket._id,
                repId: this.user._id,
                customerEmail: customerEmail,
                response: responseText,
                senderMailId,
                resolved,
            };
            this.sendTicketResponse(data).then((x) => {
                this.showingTicket = null;
            });
        },
        replyTrendyolQuestion({ selectedHistory, responseText }) {
            let data = {
                _id: selectedHistory.ticket._id,
                repId: this.user._id,
                response: responseText,
            };
            this.sendTicketResponse(data).then((x) => {
                const channelId =
                    _.get(selectedHistory, "visitor.channel._id") ||
                    _.get(selectedHistory, "conversation.visitor.channel._id");
                sendSocketMessage("user reply-trendyol-question", {
                    siteId: selectedHistory.ticket.siteId,
                    channelId,
                    message: responseText,
                    question: selectedHistory.ticket.trendyolQuestion,
                    text: responseText,
                });

                this.showingTicket = null;
            });
        },
        sendAsComment({ selectedHistory, responseText, isPrivate }) {
            let data = {
                _id: selectedHistory.ticket._id,
                repId: this.user._id,
                response: responseText,
            };
            this.sendTicketResponse(data).then((x) => {
                const channelId =
                    _.get(selectedHistory, "visitor.channel._id") ||
                    _.get(selectedHistory, "conversation.visitor.channel._id");
                if (selectedHistory.ticket.type === "instagram-mention") {
                    sendSocketMessage("meta reply-mention", {
                        siteId: selectedHistory.ticket.siteId,
                        channelId,
                        commentId: selectedHistory.ticket.metaComment.commentId,
                        mediaId: selectedHistory.ticket.metaComment.payload.media_id,
                        message: responseText,
                        isPrivate,
                        type: selectedHistory.ticket.type,
                    });
                } else {
                    sendSocketMessage("meta reply-comment", {
                        userId: this.user._id,
                        siteId: selectedHistory.ticket.siteId,
                        channelId,
                        commentId: selectedHistory.ticket.metaComment.commentId,
                        message: responseText,
                        isPrivate,
                        type: selectedHistory.ticket.type,
                    });
                }

                this.showingTicket = null;
            });
        },
        deleteComment({ selectedHistory, responseText }) {
            let data = {
                _id: selectedHistory.ticket._id,
                repId: this.user._id,
                response: responseText,
            };
            this.sendTicketResponse(data).then((x) => {
                const channelId =
                    _.get(selectedHistory, "visitor.channel._id") ||
                    _.get(selectedHistory, "conversation.visitor.channel._id");
                sendSocketMessage("meta delete-ig-comment", {
                    siteId: selectedHistory.ticket.siteId,
                    channelId,
                    commentId: selectedHistory.ticket.metaComment.commentId,
                });
                this.$message.success(this.$t("ticket.igCommentDeleteIgPost"));

                this.showingTicket = null;
            });
        },
        changeHideStatusIGComment({ selectedHistory, hide }) {
            if (selectedHistory.ticket.type !== "instagram-mention") {
                const channelId =
                    _.get(selectedHistory, "visitor.channel._id") ||
                    _.get(selectedHistory, "conversation.visitor.channel._id");
                sendSocketMessage("meta change-hide-status-of-ig-comment", {
                    siteId: selectedHistory.ticket.siteId,
                    channelId,
                    commentId: selectedHistory.ticket.metaComment?.commentId,
                    hide,
                }).then(() => {
                    this.$message.success(this.$t("ticket.igCommentHideChange"));
                });
            }
        },
        archived(item) {
            let data = {
                _id: item._id,
                repId: this.user._id,
                response: `Archived by ${this.user.name}`,
            };
            this.sendTicketResponse(data);
        },
        toggleSortOrder(columnKey) {
            if (this.currentSort.columnKey === columnKey) {
                this.currentSort.order = this.currentSort.order === "ascend" ? "descend" : "ascend";
            } else {
                this.currentSort.columnKey = columnKey;
                this.currentSort.order = "ascend";
            }
        },
        applyFilterTemplate(templateName) {
            // Bu metod, TicketFilterToolbar bileşenindeki applyFilterTemplate metodunu çağırır
            this.$refs.filterToolbar.applyFilterTemplate(templateName);
        },
        isFilterExists(filterName) {
            return this.filters.some((filter) => filter.name === filterName);
        },
        addFilter(name, value) {
            this.$refs.filterToolbar.addFilter(name, value, false);
        },
        removeFilter(name) {
            this.$refs.filterToolbar.removeFilter(name);
        },
        selectAll() {
            this.checkboxOption.selectedRowKeys = this.tickets.map((ticket) => ticket._id);
        },
        deselectAll() {
            this.checkboxOption.selectedRowKeys = [];
        },
        showBulkAssignModal() {
            this.isBulkAssignModalVisible = true;
        },
        closeBulkAssignModal() {
            this.isBulkAssignModalVisible = false;
            this.selectedBulkAgent = null;
        },
        async handleBulkAssignConfirm() {
            if (!this.selectedBulkAgent || this.selectedBulkAgent.length === 0) {
                this.$message.error(this.$t("ticket.pleaseChooseRepresent"));
                return;
            }

            const agentId = this.selectedBulkAgent[0].value;

            try {
                await Promise.all(
                    this.checkboxOption.selectedRowKeys.map((ticketId) =>
                        this.assignRepresentative({ _id: ticketId, repId: agentId })
                    )
                );
                this.$message.success(this.$t("ticket.selectedTicketSucsDelegated"));
                this.checkboxOption.selectedRowKeys = []; // Seçili öğeleri temizle
                this.fetch();
                this.closeBulkAssignModal();
            } catch (error) {
                console.error("Toplu temsilci atama hatası:", error);
                this.$message.error(this.$t("ticket.errorOccuredDuringDelegation"));
            }
        },
        async bulkCloseTickets() {
            this.$confirm({
                title: this.$t("ticket.bulkTicketClosing"),
                content: `${this.checkboxOption.selectedRowKeys.length} ${this.$t("ticket.sureWantCloseTicket")}`,
                okText: this.$t("message.close"),
                cancelText: this.$t("wp.cancel"),
                onOk: async () => {
                    try {
                        await Promise.all(
                            this.checkboxOption.selectedRowKeys.map((ticketId) =>
                                this.closeTicketAndUpdateState(ticketId)
                            )
                        );
                        this.checkboxOption.selectedRowKeys = []; // Seçili öğeleri temizle
                        this.$message.success(this.$t("ticket.selectedTicketSucsClosed"));
                        this.fetch();
                    } catch (error) {
                        console.error("Toplu bilet kapatma hatası:", error);
                        this.$message.error(this.$t("ticket.thereErrorClosingTicket"));
                    }
                },
            });
        },
        setMode(newMode) {
            this.mode = newMode;
            if (newMode === "kanban") {
                this.paginationCursor.perPage = this.kanbanFetchLimit;
                this.fetchMoreTickets();
            } else {
                this.paginationCursor.perPage = 10; // veya varsayılan liste modu limit
                this.fetch();
            }
        },
        loadMoreTickets() {
            // Daha fazla ticket yüklemek için sayfayı artır ve fetch çağır
            if (this.tickets.length < this.paginationCursor.total) {
                this.paginationCursor.page += 1;
                this.fetchMoreTickets();
            }
        },

        async onCursorChanged(newCursor) {
            this.paginationCursor = newCursor;
            await this.fetch();
        },
        isMaskContactInfo,
        maskContactInfo(val, key, length = 5) {
            return this.isMaskContactInfo(key) ? maskContactInfo(val, length) : val;
        },
        fetchMoreTickets() {
            const filters = this.generateFilterParams();
            const cursor = {
                limit: this.paginationCursor.perPage,
                skip: (this.paginationCursor.page - 1) * this.paginationCursor.perPage,
            };
            this.loading = true;
            TICKET_API.list(filters, cursor)
                .then(({ tickets, total }) => {
                    this.paginationCursor.total = total;
                    if (this.paginationCursor.page === 1) {
                        this.tickets = tickets;
                    } else {
                        this.tickets = this.tickets.concat(tickets);
                        this.tickets = _.uniqBy(this.tickets, "_id");
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        fetch() {
            const filters = this.generateFilterParams();
            const cursor = {
                limit: this.mode === "kanban" ? this.kanbanFetchLimit : this.paginationCursor.perPage,
                skip: (this.paginationCursor.page - 1) * this.paginationCursor.perPage,
            };
            this.loading = true;
            this.loadingInstance?.show();
            log("fetch", filters, cursor);
            TICKET_API.list(filters, cursor)
                .then(({ tickets, total }) => {
                    this.tickets = tickets;
                    this.total = total;
                    if (this.isInitialFetch) {
                        this.paginationCursor = {
                            ...this.paginationCursor,
                            total,
                        };
                        this.isInitialFetch = false;
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.loadingInstance?.close();
                });
        },
        toggleTicketSelection(ticketId) {
            const index = this.checkboxOption.selectedRowKeys.indexOf(ticketId);
            if (index > -1) {
                this.checkboxOption.selectedRowKeys.splice(index, 1);
            } else {
                this.checkboxOption.selectedRowKeys.push(ticketId);
            }
        },
        toggleSelectAll(columnTickets) {
            const ticketIds = columnTickets.map((ticket) => ticket._id);
            const allSelected = ticketIds.every((id) => this.checkboxOption.selectedRowKeys.includes(id));
            if (allSelected) {
                // Hepsini kaldır
                this.checkboxOption.selectedRowKeys = this.checkboxOption.selectedRowKeys.filter(
                    (id) => !ticketIds.includes(id)
                );
            } else {
                // Hepsini ekle
                this.checkboxOption.selectedRowKeys = [
                    ...new Set([...this.checkboxOption.selectedRowKeys, ...ticketIds]),
                ];
            }
        },
        getVoiceAssistantFunctions() {
            const functions = [
                {
                    type: "function",
                    function: {
                        name: "change_filter",
                        description: this.$t("ticket.changeFilterTicketPage"),
                        parameters: {
                            type: "object",
                            properties: {
                                filters: {
                                    type: "array",
                                    description: "Filters array",
                                    items: {
                                        type: "object",
                                        properties: {
                                            name: {
                                                type: "string",
                                                enum: [
                                                    "dateFilter",
                                                    "tags",
                                                    "statusList",
                                                    "subject",
                                                    "email",
                                                    "name",
                                                    "phone",
                                                    "types",
                                                    "agents",
                                                    "resolved",
                                                ],
                                                description: this.$t("ticket.nameOfFilter"),
                                            },
                                            value: {
                                                description: this.$t("ticket.filterValue"),
                                            },
                                        },
                                        required: ["name", "value"],
                                    },
                                },
                            },
                            required: ["filters"],
                        },
                    },
                },
                {
                    type: "function",
                    function: {
                        name: "delete_tickets",
                        description: this.$t("ticket.deletesSelectedTickets"),
                        parameters: {
                            type: "object",
                            properties: {
                                ticketIds: {
                                    type: "array",
                                    items: { type: "string" },
                                    description: this.$t("ticket.idTicketBeDelete"),
                                },
                            },
                            required: ["ticketIds"],
                        },
                    },
                },
                {
                    type: "function",
                    function: {
                        name: "assign_agent_to_tickets",
                        description: this.$t("ticket.assignsAgentSelectedTickets"),
                        parameters: {
                            type: "object",
                            properties: {
                                ticketIds: {
                                    type: "array",
                                    items: { type: "string" },
                                    description: this.$t("ticket.idTicketBeAssigned"),
                                },
                                agentId: {
                                    type: "string",
                                    description: this.$t("ticket.idAgentAssigned"),
                                },
                            },
                            required: ["ticketIds", "agentId"],
                        },
                    },
                },
                {
                    type: "function",
                    function: {
                        name: "change_status_tickets",
                        description: this.$t("ticket.changesStatusSelectedTicket"),
                        parameters: {
                            type: "object",
                            properties: {
                                ticketIds: {
                                    type: "array",
                                    items: { type: "string" },
                                    description: this.$t("ticket.idTicketWhoseStatus"),
                                },
                                statusTitle: {
                                    type: "string",
                                    enum: this.statusList.map((x) => x.title),
                                    description: $t("ticket.newStatus"),
                                },
                            },
                            required: ["ticketIds", "statusTitle"],
                        },
                    },
                },
                // {
                //     type: "function",
                //     function: {
                //         name: "select_tickets",
                //         description: "Selects tickets based on a criteria",
                //         parameters: {
                //             type: "object",
                //             properties: {
                //                 criteria: {
                //                     type: "string",
                //                     description: "Ticket selection criteria",
                //                 },
                //             },
                //             required: ["criteria"],
                //         },
                //     },
                // },
            ];
            log("getVoiceAssistantFunctions", functions);
            return functions;
        },
        listenVoiceAssistant() {
            log("listenVoiceAssistant");

            SYSTEM_PUBSUB.stream
                .pipe(
                    filter((x) =>
                        [
                            SYSTEM_PUBSUB.MESSAGE_TYPES.VOICE_COMMAND_RECEIVED,
                            SYSTEM_PUBSUB.MESSAGE_TYPES.VOICE_ASSISTANT_RESPONSE_RECEIVED,
                        ].includes(x.type)
                    )
                )
                .subscribe(async ({ type, payload }) => {
                    log("Voice Assistant Event", { type, payload });
                    if (type === SYSTEM_PUBSUB.MESSAGE_TYPES.VOICE_COMMAND_RECEIVED) {
                        const functions = this.getVoiceAssistantFunctions();
                        const currentFilter = this.filters.map((x) => ({ name: x.name, filterValue: x.filterValue }));
                        const filterMetas = this.$refs.filterToolbar.filterMetas
                            .map((x) => ({
                                ...x,
                                _options: typeof x.options?.(),
                            }))
                            .map((x) => {
                                delete x.filterValue;
                                delete x.options;
                                x.options = x._options;
                                delete x._options;
                                return x;
                            });
                        log("listenVoiceAssistant filterMetas", filterMetas, this.$refs.filterToolbar.filterMetas);
                        const socketMessagePayload = {
                            command: payload.command,
                            siteId: this.site._id,
                            userId: this.user._id,
                            context: {
                                page: "ticket",
                                functions,
                                message: `
                        Context Details
    - Context = "ticket"
    - currentFilter = ${JSON.stringify(currentFilter)}
    - currentSort = ${JSON.stringify(this.currentSort)}
    - currentView = ${this.mode}
    - currentGroup = "none"
    - currentSearch = ""
    - currentPagination = ${JSON.stringify(this.paginationCursor)}
    - currentSelectedTicketIds = ${JSON.stringify(this.checkboxOption.selectedRowKeys)}
    - listedTicketIds: ${JSON.stringify(this.tickets.map((x) => x._id))}
    - page = "ticket"
    - allFilterMetas =  ${JSON.stringify(filterMetas)}
    - filters rules
       - dateFilter.timeSelect: alabileceği değerler (last24h,isoWeek,-isoWeek,month,-month,day,-day,7,30) diğer tarihler için startDate ve endDate verilecek. Eğer herhangi bir tarih filtresi verilmemişse bu ayı referans al.
       - agents: atanan temsilcileri ifade eder ticket çözümleyecek olan kişidir. [{type:"agent",value:$ID$}} şeklinde olması lazım. atanmamışlar için {type:none,value:"none"} ekleyebilirsin.
       - resolved: ticket'in kapanmış mı bunu tanımlar alabileceği değerler true:kapanmış , false:aktif kapanmamış , null: hepsi
       - types: ticket type'ına tanımlar alabileceği değerler metasının içinde options kısmında yazıyor (sadece id'leri vermelisin)
       - statusList: ticket durumlarını tanımlar alabileceği değerler metasının içinde options kısmında yazıyor (sadece id'leri vermelisin)
       - tags: ticket etiketlini tanımlar alabileceği değerler metasının içinde options kısmında yazıyor (sadece id'leri vermelisin)
       - eposta: ticket'ı açan müşterinin eposta adresidir
    \`
                        `,
                            },
                        };

                        sendSocketMessage("user ai-command", socketMessagePayload);
                    } else {
                        this.handleVoiceAssistantResponse(payload);
                    }
                });
        },
        async handleVoiceAssistantResponse(response) {
            log("handleVoiceAssistantResponse", response);
            if (response.context.page !== "ticket") return;
            const { functionName, functionArgs } = response;
            if (functionName === "delete_tickets") {
                const { ticketIds } = functionArgs;
                this.checkboxOption.selectedRowKeys = ticketIds;
                await this.deleteSelectedTickets();
            } else if (functionName === "assign_agent_to_tickets") {
                const { ticketIds, agentId } = functionArgs;
                this.checkboxOption.selectedRowKeys = ticketIds;
                this.selectedBulkAgent = [{ value: agentId }];
                await this.handleBulkAssignConfirm();
            } else if (functionName === "change_status_tickets") {
                const { ticketIds, statusTitle } = functionArgs;
                this.checkboxOption.selectedRowKeys = ticketIds;
                await this.bulkChangeStatus(statusTitle);
            } else if (functionName === "select_tickets") {
                const { criteria } = functionArgs;
                // Burada kriterlere göre ticketları seçme işlemini gerçekleştirin
                // Örneğin, belirli bir duruma sahip ticketları seçmek için:
                this.selectTicketsByCriteria(criteria);
            } else if (functionName === "change_filter") {
                // Mevcut implementasyon
                this.filters = [];
                const { filters } = functionArgs;
                filters.forEach((filter) => {
                    const filterMeta = this.$refs.filterToolbar.filterMetas.find((x) => x.name === filter.name);
                    if (filterMeta) {
                        this.$refs.filterToolbar.addFilter(filter.name, filter.value, false);
                    }
                });
            }
        },
        async bulkChangeStatus(statusTitle) {
            try {
                await Promise.all(
                    this.checkboxOption.selectedRowKeys.map((ticketId) =>
                        this.handleChangeStatus(ticketId, statusTitle)
                    )
                );
                this.checkboxOption.selectedRowKeys = []; // Seçili öğeleri temizle
                this.$message.success(this.$t("ticket.selectedTicketsSucsUpdated"));
                this.fetch();
            } catch (error) {
                console.error("Toplu durum değiştirme hatası:", error);
                this.$message.error(this.$t("ticket.errorWhileChangingStatus"));
            }
        },
        selectTicketsByCriteria(criteria) {
            // Örnek bir implementasyon:
            // criteria'ya göre this.tickets dizisinden uygun ticketları seçip, checkboxOption.selectedRowKeys'e ekleyin
            const selectedTickets = this.tickets.filter((ticket) => {
                // Kriterlerinize göre filtreleme yapın
                // Örneğin, durumu "Açık" olan ticketları seçmek için:
                return ticket.status === criteria;
            });
            this.checkboxOption.selectedRowKeys = selectedTickets.map((ticket) => ticket._id);
        },
        getUniqueChannels() {
            const channels = new Set();
            this.tickets.forEach((ticket) => {
                const channelName =
                    _.get(ticket, "visitor.channel.name") || _.get(ticket, "conversation.visitor.channel.name");
                if (channelName) {
                    channels.add(channelName);
                }
            });
            return Array.from(channels).map((channel) => ({
                id: channel,
                label: channel,
            }));
        },
        viewTicketFromKanban(ticket) {
            const index = this.tickets.findIndex((x) => x._id === ticket._id);
            this.view(ticket, index);
        },
    },
    mounted() {
        this.loadingInstance = VeLoading({
            target: document.querySelector("#ticket-list-table"),
            name: "wave",
        });
        this.fetchTopics();
        this.fetchTicketStatusList();
        this.toggleSortOrder("createdDate");
        this.fetch();
        document.addEventListener("keydown", this.handleKeyDown);
        this.$once("hook:beforeDestroy", () => {
            document.removeEventListener("keydown", this.handleKeyDown);
        });
        this.applyFilterTemplate(this.defaultFilterTemplate);
        this.listenVoiceAssistant();
        this.checkVoiceAssistantModal();

        // Seçilen kolonları localStorage'dan okuyalım
        const savedColumns = JSON.parse(localStorage.getItem("ticketListColumns"));
        if (savedColumns && Array.isArray(savedColumns)) {
            this.selectedColumns = savedColumns;
        } else {
            // Contact Property Fields varsayılan olarak seçili olmayacak
            this.selectedColumns = this.ticketFields.map((field) => field.key);
        }
    },
    beforeDestroy() {
        clearInterval(this.refreshTimerId);
    },
    watch: {
        defaultFilterTemplate: {
            handler(newTemplate) {
                this.applyFilterTemplate(newTemplate || "this-week-open-tickets");
            },
        },
        filters: {
            handler() {
                this.paginationCursor.page = 1;
                if (this.mode === "kanban") {
                    this.paginationCursor.perPage = this.kanbanFetchLimit;
                }
                this.isInitialFetch = true;
                this.fetch();
            },
            deep: true,
        },
        paginationCursor: {
            deep: true,
            handler(newVal, oldVal) {
                if (!this.isInitialFetch && (newVal.page !== oldVal.page || newVal.perPage !== oldVal.perPage)) {
                    log("paginationCursor changed", { newVal, oldVal });
                    this.fetch();
                }
            },
        },
        contactProperties: {
            handler() {
                // Contact Property Fieldleri güncelle
                this.contactPropertyFields;
                this.allColumns;
            },
            immediate: true,
        },
    },
    created() {},
});
</script>

<style lang="scss">
.ticket-list {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .bulk-action-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        background-color: #f8f8f8;
        border-bottom: 1px solid #ccc;

        .selected-count {
            font-weight: bold;
        }

        .bulk-actions {
            display: flex;
            gap: 10px;

            .bulk-action-button {
                display: flex;
                align-items: center;
                gap: 5px;

                .keyboard-shortcut {
                    font-size: 0.8rem;
                    font-weight: bold;
                    color: #000;
                    background-color: #f1f1f1;
                    padding: 2px 5px;
                    border-radius: 5px;
                    border: 1px solid #ccc;
                }
            }
        }
    }

    .toolbar-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        .keyboard-shortcut {
            margin-right: 3px;

            font-size: 0.8rem;
            font-weight: bold;
            color: #000;
            background-color: #f1f1f1;
            padding: 2px 5px;
            border-radius: 5px;
            border: 1px solid #ccc;
            width: max-content;
            height: 19px;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
        }
    }

    .agent-cell {
        cursor: pointer;
        display: flex;
        align-items: center;

        .agent-name {
            margin-left: 8px;
        }
    }

    .assign-link {
        color: #3699ff;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }

    .chip {
        display: inline-block;
        padding: 5px 10px;
        border-radius: 16px;
        font-size: 12px;
        font-weight: 600;
        color: #fff;
        text-align: center;

        &.resolved {
            background-color: #4caf50; // Yeşil renk
        }

        &.unresolved {
            background-color: #ff9800; // Sarı-turuncu renk
        }

        &.instagram-comment {
            border: 1px solid #ff5722; // Orange border
            color: #ff5722; // Orange text
        }

        &.instagram-mention {
            border: 1px solid #3f51b5; // Blue border
            color: #3f51b5; // Blue text
        }

        &.page-comment {
            border: 1px solid #009688; // Blue border
            color: #009688; // Teal text
        }

        &.offline-message {
            border: 1px solid #e7097f; // Blue border
            color: #e7097f; // Teal text
        }
    }

    .ticket-transactions {
        display: flex;
        gap: 10px;
        align-items: center;

        .btnAction {
            background: none;
            border: none;
        }
    }

    .ticket-select {
        width: 100%;

        .ant-select-selection {
            border-color: transparent !important;
        }
    }

    .custom-table {
        background-color: #ffffff;
        border-radius: 6px;
        padding: 10px 20px;
    }

    .actionButton {
        border: none;
        box-shadow: none;
    }

    .view-switcher {
        display: flex;
        align-items: center;

        .supsis-button-group {
            display: flex;

            .supsis-button {
                &:first-child {
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                }

                &:last-child {
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    margin-left: -1px; // Butonları birleştirmek için
                }

                i {
                    font-size: 14px;
                }
            }
        }
    }
}

.userInfo {
    &.first {
        color: #3699ff;
        font-size: 16px;
        font-weight: 500;
        padding-top: 15px;
        line-height: 1;
    }

    &.sec {
        color: #181c32;
        font-size: 14px;
        font-weight: 300;
    }
}

.waiting-ticket-messages {
    max-height: 300px !important;
    overflow: scroll;
}

//#awaiting-message-details {
//    .ant-modal {
//        width: 910px !important;
//    }
//}

#ticket-response {
    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 5px;
        padding: 5px;
        border-top: 1px solid var(--color-border-default);
    }
}

.agent-picker-modal {
    .ant-modal-content {
        padding: 20px;
    }
}

.column-settings-modal {
    .ant-modal-content {
        width: 600px !important;
    }
}
</style>
